import { User } from './user';

enum ClientType {
  Corporate = 'corporate',
  Distributor = 'distributor',
  Expert = 'expert'
}

export enum ClientPlanType {
  Credits = 'credits',
  Subscription = 'subscription',
  Unknown = 'unknown'
}

export class Agent extends User {
  clientIds: [string];
  blocked: boolean;
  uuid: any;
  clients: [any];
  isCreator: boolean;
  creatorAccountId: string;
  notificationsCfg: any;
  partner: any;
  ownerConfig: any;
  onlyOwner: boolean;
}

export class Profile extends Agent {
  clients: [any];
  roleOptions: Role;
  selectedClientId: any;
  isStudent: boolean;
  planType: string;
  planEndDate: any;
  clientType: ClientType;
  isScormClientAdmin: boolean;
  clientPlanType?: ClientPlanType;
}

export interface Role {
  group?: string;
  isAgent?: boolean;
  name?: string;
  priority?: number;
  scope?: string;
}
